import styled from 'styled-components/native';

export default styled.View`
  flex: 1;
  background-color: ${({ theme }) => theme.audioNote.wave};
  margin: 0 -15px -15px -15px;
  justify-content: flex-end;
  align-items: center;
`;
